const rootURL = 'https://article-api.onrender.com/api/';
const articlesURL = 'https://article-api.onrender.com/api/articles';
const tagsURL = 'https://article-api.onrender.com/api/tags';

export { rootURL, tagsURL, articlesURL };
